import GoogleMapsApi from "../../GoogleMapsApi";

require("@modules/tools/ko.bootstrapSelect");
require("@modules/tools/ko.bootstrap-select");
require("@modules/tools/ko.bootstrapSelect.typeahead");
require("@modules/tools/ko.scrollTo");
require("@plugins/knockout-multi-select/main");

var dataLayerService = require("@modules/services/dataLayerService");
var querystring = require("querystring");
var loadedQuerystring = querystring.parse();

// Google Maps
var gApiKey;
var gmapApi;
// prevent loading for gwoe3 address question
if (document.querySelector(".gwoe-2023 [name='ApplicantAddress']") == null &&
    document.querySelector(".gwoe-2023 [name='MI_MailingStreet']") == null &&
    document.querySelector(".member-pbp [name='PermanentAddress1']") == null &&
    document.querySelector(".member-pbp [name='PermanentAddress1']") == null &&
    document.querySelector(".gwoe-2022 [name='ApplicantAddress']") == null &&
    document.querySelector(".gwoe-2022 [name='MI_MailingStreet']") == null) {
    gApiKey = window.scan.googleMapsApiKey !== undefined ? window.scan.googleMapsApiKey : "";
    gmapApi = new GoogleMapsApi(gApiKey);
}

var utils = require("@modules/utils");
var ko = require("knockout");
var $ = require("jquery");
var ProviderSearchViewModel = require("@modules/tools/provider-search/providerSearchViewModel");

var gtmDataLayerPushDebounced = utils.debounce(function (parameters, defaultParameters, resultsCount) {
    var dataLayer = window.dataLayer || [];
    var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
    var jsonObject = {
        event: "gaPageview",
        eventCategory: "Pageview",
        eventAction: url,
        eventLabel: "Doctors Search"
    };

    // Note: this was added during the mobile-telehealth work but unsure we're keeping it
    //if (!isNaN(resultsCount)) {
    //    var eventActionName = "ResultsCount";
    //    if (resultsCount == 0) {
    //        eventActionName = "ZeroResults";
    //    }
    //    dataLayer.push({
    //        event: "gaEvent",
    //        eventCategory: "Lookup-doctors",
    //        eventAction: eventActionName,
    //        eventLabel: resultsCount
    //    });
    //    jsonObject.resultsCount = resultsCount;
    //}

    if (parameters.year && parameters.year !== defaultParameters["year"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "Year",
            eventLabel: parameters.year
        });
        jsonObject.providerYear = parameters.year;
    }

    // Note: this could potentially be PHI so leave out for now
    //if (parameters.zipOrAddress && parameters.zipOrAddress !== defaultParameters["zipOrAddress"]) {
    //    dataLayer.push({
    //        event: "gaEvent",
    //        eventCategory: "Lookup-doctors",
    //        eventAction: "Address",
    //        eventLabel: parameters.zipOrAddress
    //    });
    //    jsonObject.providerAddress = true;
    //}

    if (parameters.name && parameters.name !== defaultParameters["name"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "Name",
            eventLabel: parameters.name
        });
        jsonObject.providerName = true;
    }
    if (parameters.radius && parameters.radius !== defaultParameters["radius"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "MilesFromAddress",
            eventLabel: parameters.radius + " Miles"
        });
        jsonObject.providerRadius = parameters.radius;
    }
    if (parameters.groups.length) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "MedicalGroups",
            eventLabel: parameters.groups
        });
        jsonObject.providerGroup = parameters.groups;
    }

    if (parameters.gender.length) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "Gender",
            eventLabel: parameters.gender
        });
        jsonObject.providerGender = parameters.gender;
    }

    if (parameters.language.length) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "Languages",
            eventLabel: parameters.language
        });
        jsonObject.providerLanguage = parameters.language;
    }
    if (parameters.pcponly && parameters.pcponly !== defaultParameters["pcponly"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "PCPOnly",
            eventLabel: parameters.pcponly
        });
        jsonObject.providerPCPonly = parameters.pcponly;
    }

    if (parameters.inofficevisits && parameters.inofficevisits !== defaultParameters["inofficevisits"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "InOfficeVisits",
            eventLabel: parameters.inofficevisits
        });
        jsonObject.providerInOfficeVisits = parameters.inofficevisits;
    }
    if (parameters.mobileavailable && parameters.mobileavailable !== defaultParameters["mobileavailable"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "MobileAvailable",
            eventLabel: parameters.mobileavailable
        });
        jsonObject.providerMobileAvailable = parameters.mobileavailable;
    }
    if (parameters.mobileonly && parameters.mobileonly !== defaultParameters["mobileonly"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "MobileOnly",
            eventLabel: parameters.mobileonly
        });
        jsonObject.providerMobileOnly = parameters.mobileonly;
    }
    if (parameters.telehealthavailable && parameters.telehealthavailable !== defaultParameters["telehealthavailable"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "TelehealthAvailable",
            eventLabel: parameters.telehealthavailable
        });
        jsonObject.providerTelehealthAvailable = parameters.telehealthavailable;
    }
    if (parameters.telehealthonly && parameters.telehealthonly !== defaultParameters["telehealthonly"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "TelehealthOnly",
            eventLabel: parameters.telehealthonly
        });
        jsonObject.providerTelehealthOnly = parameters.telehealthonly;
    }
    if (parameters.lgbtqplus && parameters.lgbtqplus !== defaultParameters["lgbtqplus"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "LGBTQ+ Affirming",
            eventLabel: parameters.lgbtqplus
        });
        jsonObject.providerLgbtqplus = parameters.lgbtqplus;
    }

    if (parameters.specialties.length) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "Specialty",
            eventLabel: parameters.specialties
        });
        jsonObject.providerSpecialty = parameters.specialties;
    }
    if (parameters.panelStatusCode.length) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "Panel Status",
            eventLabel: parameters.panelStatusCode
        });
        jsonObject.providerPanelStatusCode = parameters.panelStatusCode;
    }
    if (parameters.title.length) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "Title",
            eventLabel: parameters.title
        });
        jsonObject.providerTitle = parameters.title;
    }
    if (parameters.plans != undefined && parameters.plans.length) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-doctors",
            eventAction: "Plans",
            eventLabel: parameters.plans
        });
        jsonObject.providerPlan = parameters.plans;
    }
    dataLayer.push(jsonObject);

    var providerOptionsCSV = [];
    if (parameters.pcponly) { providerOptionsCSV.push("PcpOnly"); }
    if (parameters.inofficevisits) { providerOptionsCSV.push("InOfficeVisits"); }
    if (parameters.mobileavailable) { providerOptionsCSV.push("MobileAvailable"); }
    if (parameters.mobileonly) { providerOptionsCSV.push("MobileOnly"); }
    if (parameters.telehealthavailable) { providerOptionsCSV.push("TelehealthAvailable"); }
    if (parameters.telehealthonly) { providerOptionsCSV.push("TelehealthOnly"); }
    if (parameters.lgbtqplus) { providerOptionsCSV.push("LGBTQ+ Affirming"); }

    var jsonObjectCustomDimensions = {
        event: "providerFilter",
        providerPlan: parameters.plans,
        providerGroup: parameters.groups,
        providerGender: parameters.gender,
        providerLanguage: parameters.language,
        providerSpecialty: parameters.specialties,
        providerName: parameters.name,
        providerOptions: providerOptionsCSV.join()
    };
    dataLayer.push(jsonObjectCustomDimensions);

}, 2000);

// only bind knockout for provider search when we're on the provider search page.
if ($("#provider-search").length > 0) {
    ko.applyBindings(new ProviderSearchViewModel(gtmDataLayerPushDebounced, gmapApi));
    $(".hide-load").removeClass("hide-load");
    $(".tool-load").removeClass("tool-load");
}

// hack added to circumvent accordion logic eating the click event
if ($(".allow-online-registration").length > 0) {
    $(".allow-online-registration").click(function (e) {
        e.preventDefault();
        window.location.href = $(this).attr("href");
    });
}
$("form#changePcpForm").submit(function () {
    var dataLayer = window.dataLayer || [];
    dataLayer.push({
        event: "gaEvent",
        eventCategory: $("form#changePcpForm").data("category"),
        eventAction: $("form#changePcpForm").data("action"),
        eventLabel: $("form#changePcpForm").data("label")
    });

    dataLayer.push({
        event: "myCareCTA",
        "effectiveDate": $('input[name="effectiveDate"]:checked').val(),
        "ctaLink": $("form#changePcpForm").find("button").text()
    });
});

$("#provider-search")
    .find(".google-address-lookup")
    .keydown(function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

// if we're in the Find My PCP step process then trigger datalayer events
var isFindMyPcp = loadedQuerystring["findmypcp"];
if (isFindMyPcp != undefined) {

    // Note: step 1 had to be captured in physicianResultViewModel.js because of conflict with kojs data-bind on click event

    $(".provider-link").on("click", function () {
        var dataLayerEvent = {
            event: "PCPFinder",
            step_name: "select location",
            step_number: "2"
        };
        dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
    });

    $("#onlineEnrollmentZipCode").on("input", function () {
        if ($(this).val().length == 5) {
            var dataLayerEvent = {
                event: "PCPFinder",
                step_name: "find plans",
                step_number: "3"
            };
            dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
        }
    });

}
